import { inView, animate } from 'motion';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import './main.css';

import Navi from './Blocks/HeaderNavigation/navi';

Alpine.plugin(intersect);

window.Alpine = Alpine;
Alpine.start();

const domReady = () => {
  Navi();
  const banner = document.querySelectorAll('.banner');
  const fullImageBanner = document.querySelectorAll('.full-image-banner');
  const simpleHeader = document.querySelectorAll('.simple-header');
  const heroMarquee = document.querySelectorAll('.hero-marquee');
  const marquee = document.querySelectorAll('.marquee');
  const inlineForm = document.querySelectorAll('.inline-form');
  const fixedScrolls = document.querySelectorAll('.fixed-scroll');
  const stickyStats = document.querySelectorAll('.sticky-stats');
  const numberCounter = document.querySelectorAll('.countup');
  let transitionableBlocks = document.querySelectorAll('.transition-block');
  const forms = document.querySelectorAll('.gform_wrapper form');
  const carousels = document.querySelectorAll('.carousel');
  const projectSliders = document.querySelectorAll('.project-slider');

  if (banner.length) {
    import('./Blocks/Banner/banner.js').then(({ default: Banner }) => {
      Banner();
    });
  }

  if (fullImageBanner.length) {
    import('./Blocks/FullImageBanner/full-image-banner.js').then(
      ({ default: FullImageBanner }) => {
        FullImageBanner();
      },
    );
  }

  if (simpleHeader.length) {
    import('./Blocks/SimpleHeader/simple-header.js').then(
      ({ default: SimpleHeader }) => {
        SimpleHeader();
      },
    );
  }

  if (heroMarquee.length) {
    import('./Blocks/Hero/hero.js').then(({ default: Hero }) => {
      Hero();
    });
  }

  if (marquee.length) {
    import('./Blocks/Marquee/marquee.js').then(({ default: Marquee }) => {
      Marquee();
    });
  }
  if (numberCounter.length) {
    import('./Blocks/StatBlockNumber/countup.js').then(
      ({ default: Countup }) => {
        Countup();
      },
    );
  }

  if (fixedScrolls.length) {
    import('./Blocks/FixedScroll/fixedscroll.js').then(
      ({ default: FixedScroll }) => {
        FixedScroll();
      },
    );
  }
  if (stickyStats.length) {
    import('./Blocks/StickyStats/stickystats.js').then(
      ({ default: stickyStats }) => {
        stickyStats();
      },
    );
  }

  if (forms.length) {
    import('./fileUploadElement.js').then(({ default: fileUploadElement }) => {
      forms.forEach((form) => {
        fileUploadElement(form);
      });
    });
  }

  if (carousels.length) {
    import('./Blocks/Carousel/carousel.js').then(({ default: Carousel }) => {
      Carousel();
    });
  }

  if (projectSliders.length) {
    import('./Blocks/ProjectSlider/projectslider.js').then(({ default: ProjectSlider }) => {
      ProjectSlider();
    });
  }

  let inViewStop = inView(transitionableBlocks, ({ target }) => {
    target.classList.add('is-visible');
    //animate(
    //  target,
    //  { opacity: 1, transform: 'none' },
    //  { delay: 0.2, duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
    //);

    return () => {
      target.classList.remove('is-visible');
      //animate(
      //  target,
      //  { transform: 'translateY(60px)' },
      //  { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
      //);
    };
  });

  document.addEventListener('block:load', () => {
    transitionableBlocks = document.querySelectorAll('.transition-block');
    transitionBlocks = document.querySelectorAll('.transition');

    inViewStop();
    inViewStop = inView(transitionableBlocks, ({ target }) => {
      target.classList.add('is-visible');
      //animate(
      //  target,
      //  { opactiy: 1, transform: 'none' },
      //  { delay: 0.2, duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
      //);

      return () => {
        target.classList.remove('is-visible');
        //animate(
        //  target,
        //  { transform: 'translateY(60px)' },
        //  { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
        //);
      };
    });
  });
};

document.addEventListener('DOMContentLoaded', domReady);
